import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

export type BackofficeLanguage = 'th' | 'en';

const LANGUAGE_STORAGE_KEY = 'yarrowpass-bo-lang';
const DEFAULT_LANGUAGE: BackofficeLanguage = 'th';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  constructor(
    private translocoService: TranslocoService,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  initialize(): void {
    this.applyLanguage(this.readStoredLanguage());
  }

  get activeLanguage(): BackofficeLanguage {
    const activeLanguage = this.translocoService.getActiveLang();
    return this.isSupportedLanguage(activeLanguage)
      ? activeLanguage
      : DEFAULT_LANGUAGE;
  }

  setLanguage(language: BackofficeLanguage): void {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    this.applyLanguage(language);
  }

  private applyLanguage(language: BackofficeLanguage): void {
    this.document.documentElement.lang = language;
    this.translocoService.setActiveLang(language);
  }

  private readStoredLanguage(): BackofficeLanguage {
    const storedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return this.isSupportedLanguage(storedLanguage)
      ? storedLanguage
      : DEFAULT_LANGUAGE;
  }

  private isSupportedLanguage(
    language: string | null,
  ): language is BackofficeLanguage {
    return language === 'th' || language === 'en';
  }
}
